"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecipeByIdWithCookbooksQuery = exports.getRecipeByIdQuery = void 0;
const client_1 = require("@apollo/client");
const recipePreviewFragment_1 = require("../fragments/recipePreviewFragment");
exports.getRecipeByIdQuery = client_1.gql `
  query GetRecipeById($id: String!) {
    getRecipeById(id: $id) {
      ...RecipePreview
    }
  }

  ${recipePreviewFragment_1.recipePreviewFragment}
`;
exports.getRecipeByIdWithCookbooksQuery = client_1.gql `
  query GetRecipeByIdWithCookbooks($id: String!) {
    getRecipeById(id: $id) {
      cookbookLookup {
        cookbookName
        cookbookId
        sectionName
        sectionId
      }
      ...RecipePreview
    }
  }

  ${recipePreviewFragment_1.recipePreviewFragment}
`;
//# sourceMappingURL=GetRecipeById.js.map